import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import products from "../data/products";

export default function HomeProductsPreview() {
    const navigate = useNavigate();

    return (
        <section className="py-20 md:py-24">
            {/* OUTER CONTAINER */}
            <div className="max-w-7xl mx-auto px-4 md:px-6 flex justify-center">

                {/* ✅ MAIN GLASS BOX */}
                <div
                    className="
                        w-full
                        max-w-5xl
                        bg-black/55
                        backdrop-blur-sm
                        rounded-3xl
                        shadow-2xl
                        px-6 md:px-12
                        py-12 md:py-14
                        text-center
                    "
                >
                    {/* Heading */}
                    <motion.h2
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5 }}
                        viewport={{ once: true }}
                        className="text-3xl md:text-4xl font-extrabold text-[#ffb3b8]"
                    >
                        हमारे लोकप्रिय उत्पाद
                    </motion.h2>

                    {/* Description */}
                    <motion.p
                        initial={{ opacity: 0 }}
                        whileInView={{ opacity: 1 }}
                        transition={{ delay: 0.2, duration: 0.5 }}
                        viewport={{ once: true }}
                        className="mt-4 text-gray-200 max-w-xl mx-auto text-sm md:text-base"
                    >
                        श्री बालाजी मसाले के चुनिंदा और सबसे अधिक पसंद किए जाने वाले प्रीमियम मसाले

                    </motion.p>

                    {/* Products Grid */}
                    <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-8 max-w-3xl mx-auto">
                        {products.slice(0, 4).map((product, index) => (
                            <motion.div
                                key={product.id}
                                initial={{ opacity: 0, y: 30, scale: 0.95 }}
                                whileInView={{ opacity: 1, y: 0, scale: 1 }}
                                transition={{ duration: 0.4, delay: index * 0.1 }}
                                viewport={{ once: true }}
                                onClick={() => navigate("/products")}
                                className="
                                    cursor-pointer
                                    bg-white
                                    rounded-xl
                                    shadow-md
                                    p-5
                                    hover:shadow-xl
                                    transition
                                "
                            >
                                <img
                                    src={product.variants[0].image}
                                    alt={product.name}
                                    className="h-32 md:h-36 mx-auto object-contain transition-transform duration-300 hover:scale-105"
                                />

                                <h3 className="mt-4 text-base md:text-lg font-bold text-[#7a0c18]">
                                    {product.name}
                                </h3>
                            </motion.div>
                        ))}
                    </div>

                    {/* Button */}
                    <motion.button
                        initial={{ opacity: 0, y: 15 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.6, duration: 0.4 }}
                        viewport={{ once: true }}
                        onClick={() => navigate("/products")}
                        className="
                            mt-12
                            bg-[#7a0c18]
                            text-white
                            px-8
                            py-3
                            rounded-lg
                            font-semibold
                            hover:bg-[#930e21]
                            transition
                        "
                    >
                        सभी उत्पाद देखें
                    </motion.button>

                </div>
            </div>
        </section>
    );
}
